export default __webpack_public_path__ + "static/foot-bosch-alt-ee1b8d7c19958fa13060e898c9e1e5b4.png";